function Mission() {
  return (
    <section className="mission-section py-5">

      <div className="container">

        <div className="text-center mb-5">

          <h2 className="fw-bold">
            Our Commitment
          </h2>

          <p className="text-secondary">
            Hospitality with Heart
          </p>

        </div>

        <div className="row">

          <div className="col-lg-4 mb-4">

            <div className="mission-card">

              <h3>Our Mission</h3>

              <p>
                To provide exceptional hospitality through comfortable
                accommodation, excellent customer service, and a peaceful
                environment that makes every guest feel at home.
              </p>

            </div>

          </div>

          <div className="col-lg-4 mb-4">

            <div className="mission-card">

              <h3>Our Vision</h3>

              <p>
                To become the preferred residency in Courtallam by offering
                quality service, modern facilities, and memorable experiences
                for every visitor.
              </p>

            </div>

          </div>

          <div className="col-lg-4 mb-4">

            <div className="mission-card">

              <h3>Our Values</h3>

              <p>
                Integrity, cleanliness, hospitality, customer satisfaction,
                affordability, and continuous improvement are the values that
                guide everything we do.
              </p>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
}

export default Mission;